import { styled } from '@mui/material/styles';
import { COLOR, TRANSPARENT_COLOR } from '@src/styles/color';
import { IconButton } from '@mui/material';
import { MOBILE_BREAKPOINT } from '@src/constants';

const StyledNoDataProjectList = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  padding: 0px;
  height: ${(props) => props.height || '100%'};
  justify-content: center;

  .no-data-text {
    color: ${COLOR.label2[64]};
    font-size: 14px;
    font-weight: 400;
  }
`;

const StyledProjectList = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const StyledProjectListHeader = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  height: 40px;

  .header-left {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .select-all-checkbox {
    padding: 0;
    margin-left: 16px;
    color: ${COLOR.darkBlue} !important;
  }

  .title {
    font-weight: 700;
    font-size: 20px;
    color: #1c1c1e;
  }

  .filter-title {
    min-width: 240px;
  }

  .filter-item {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
  }

  .text-field-project {
    background-color: ${COLOR.white};
    width: 320px;

    .MuiOutlinedInput-root {
      width: 320px;
      height: 40px;
      padding: 8px 12px 8px 12px;
      gap: 8px;
      border-radius: 8px;
    }

    .MuiInputLabel-root {
      font-size: 14px;
    }
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}px) {
    .text-field-project {
      width: 240px;

      .MuiOutlinedInput-root {
        width: 240px;
      }
    }
  }
`;

const StyledTitleProject = styled('div')`
  cursor: pointer;
  ${({ bulkDeleteProjectsEnabled }) =>
    bulkDeleteProjectsEnabled && 'margin-left: -12px'};
  .item {
    display: flex;
    align-items: center;
    gap: 8px;
    min-height: 52px;
  }

  .item-title-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    table-layout: fixed;
    max-width: 505px;
    min-width: 440px;

    .edit-title {
      outline: none;
      border: 0px;
      background-color: transparent;
      border-bottom: 1px solid ${COLOR.light};
      width: 100%;
      font-weight: 550;
      height: 30px;
      color: ${COLOR.darkBlue};
      font-size: 14px;
    }

    .display-title {
      display: flex;
      flex-direction: column;
      height: 100%;
      width: 100%;

      .title {
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        width: 100%;

        .item-title {
          height: 22px;
          display: flex;
          align-items: center;
          max-width: 80%;
          color: rgba(28, 28, 30, 1);

          .text {
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            font-size: 14px;
            font-weight: 510;
            line-height: 24px;
          }
        }

        .edit-button {
          width: 20px;
          height: 20px;
          margin-left: 4px;
          width: 12px;
          height: 12px;
          color: ${COLOR.darkBlue};
          opacity: 0.75;
          padding: 14px;
        }
      }

      .title-desc {
        opacity: 0.8;
        font-size: 12px;
        font-style: normal;
        margin-right: 4px;
        font-weight: 400;
        line-height: 16px;
        letter-spacing: -0.4px;
        color: ${COLOR.label[80]};
      }
    }
    .action {
      display: flex;
      gap: 4px;
    }
  }

  .item-title-icon {
    background-color: ${({ newUiProjectsEnabled }) =>
      newUiProjectsEnabled ? 'transparent' : COLOR.gray};
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    border-radius: 8px;
    color: ${COLOR.darkBlue};
  }

  .item-title {
    font-size: 14px;
    font-weight: 510;
    color: ${COLOR.indigo.darkGray};
    max-width: 400px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    cursor: pointer;
  }

  .item-created-at {
    font-size: 12px;
    font-weight: 400;
    color: ${COLOR.label[64]};
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}px) {
    .item-title {
      max-width: 150px;
    }
  }
`;

const StyledIconButton = styled(IconButton)`
  width: ${({ width }) => width || 'auto'};
  padding: ${({ padding }) => padding || '0px'};
  height: ${({ height }) => height || '10px'};
  border-radius: ${({ borderRadius }) => borderRadius || '100%'};
  /* border: 1px solid ${COLOR.light}; */
  background: ${({ focus }) => focus && TRANSPARENT_COLOR.dark};

  color: ${({ color, disabled }) =>
    disabled ? COLOR.secondary[32] : color || COLOR.darkBlue};

  .icon-disabled {
    color: ${COLOR.iconDisabledColor};
  }

  .text-action {
    font-size: 14px;
    color: ${COLOR.darkBlue};
    &:hover {
      color: ${COLOR.black};
    }
  }
  .icon-morevert {
    opacity: 0.64;
    &:hover {
      opacity: 1;
    }
  }
  &:hover {
    background-color: ${(props) => props.isDisableHover && 'transparent'};
  }
`;

const StyledBannerCreateSampleProject = styled('div')`
  padding: 12px;
  gap: 16px;
  display: flex;
  border: 1px solid #3c3c4329;
  background-color: #ffffff;
  z-index: 1000;
  border-radius: 16px;
  bottom: 67px;
  justify-content: space-between;
  .close-icon-container {
    display: flex;
    align-items: center;
    .close-icon {
      cursor: pointer;
      color: #1e164ea3;
    }
  }

  .circular-progress {
    color: ${COLOR.darkBlue};
  }

  .banner-content {
    margin-top: 5px;
    .banner-content-title {
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: -0.4px;
      color: #000000;
      margin-bottom: 8px;
    }
    .banner-content-description {
      p {
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: -0.4px;
        color: #1c1c1ea3;
      }
    }
  }

  .content-button-container {
    display: flex;
    align-items: center;
    gap: 8px;

    .button-gradient {
      padding: 8px 12px;
      width: max-content;
      background: transparent;
      cursor: pointer;
      border: none;
      color: transparent;
      height: 40px;
      box-sizing: border-box;
      background-clip: text;
      -webkit-background-clip: text;
      background-image: linear-gradient(90deg, #ff6a6a, #8f6aff);
      -webkit-text-fill-color: transparent;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: -0.4px;
      text-align: center;
      vertical-align: middle;
      position: relative;

      &:before {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: 12px;
        padding: 2px;
        border: 1px solid #3c3c4329;
      }
      &:hover {
        &:before {
          background: ${TRANSPARENT_COLOR.dark};
        }
      }
    }
  }
`;

export {
  StyledProjectList,
  StyledProjectListHeader,
  StyledTitleProject,
  StyledIconButton,
  StyledBannerCreateSampleProject,
  StyledNoDataProjectList,
};
